
(() => {
  // ---------- tiny helpers ----------
  let BOOTING = true;
  let slideObserver = null; // IntersectionObserver for dot-nav active state
  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));
  const money = (c) => { try { return Shopify.formatMoney(c, window.theme?.moneyFormat || "${{amount}}"); } catch { return `$${(c/100).toFixed(2)}`; } };
  const withW = (u,w)=>{ try{const x=new URL(u,location.origin); x.searchParams.set('width',String(w)); return x.toString();} catch { return u + (u.includes('?')?'&':'?') + 'width=' + w; } };
  const srcset=(u,a=[200,300,400,500,600,700,800,1000])=>a.map(w=>`${withW(u,w)} ${w}w`).join(', ');
  const GALLERY_SIZES = '(max-width:699px) calc(100vw - 40px),(max-width:999px) calc(100vw - 64px), min(1100px, 819px - 96px)';
  // Resolve AFTER the browser has painted the current frame (rAF fires pre-paint, the
  // nested setTimeout runs post-paint) — used to keep heavy rebuilds off the interaction.
  const afterPaint = () => new Promise(r => requestAnimationFrame(() => setTimeout(r, 0)));
  const getCookieVal = n => { const c = document.cookie.split(';').map(s=>s.trim()).find(s=>s.startsWith(n+'=')); return c ? decodeURIComponent(c.slice(n.length+1)) : null; };
  const urlVariant = (() => { try { const v=new URL(location.href).searchParams.get('variant'); return v ? Number(v) : null; } catch { return null; } })();
  const fromQuiz = !!urlVariant && (() => { try { return new URL(location.href).searchParams.get('jfq') === '1'; } catch { return false; } })();
  let fromCookiePreset = false;
  let fromPantyCookiePreset = false;
  let userChoseBraSize = false; // set true when user explicitly clicks a band or cup
  let quizNoteEl = null;
  let lastProduct = null;
  if (fromQuiz) {
    fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:{_jfq_src:'1'}}) }).catch(()=>{});
  }
  const hasScene7 = m => typeof m?.alt === 'string' && /scene7/i.test(m.alt);

  // ---------- PDP scope ----------
  const picker = document.querySelector('variant-picker.variant-picker');
  if (!picker) return;

  const SCOPE  = picker.closest('.product') || picker.closest('section') || picker.closest('main') || document;
  const IN_SCOPE = (node) => !!node && (node === SCOPE || SCOPE.contains(node));

  const formId = picker.getAttribute('form-id');
  const form   = document.getElementById(formId) || qs(`#${CSS.escape(formId)}`);
  if (!form || !IN_SCOPE(form)) return;

  const atcBtn = form.querySelector('button[type="submit"],[name="add"]');
  const priceListEl   = qs('.price-list', SCOPE) || qs('price-list', SCOPE);
  const priceNode     = (priceListEl && priceListEl.querySelector('sale-price')) || qs('.price-list .h4, .price-list [data-price]', SCOPE) || qs('.price-list', SCOPE);
  const buyButtons    = qs('buy-buttons.buy-buttons', SCOPE);

  const fsByLegend = (startsWith) =>
    qsa('.variant-picker__option', picker).find(fs => (qs('legend',fs)?.textContent||'').trim().toLowerCase().startsWith(startsWith));
  const sizeFS   = fsByLegend('size');
  const colorFS  = fsByLegend('color');

  const sizePop  = sizeFS?.querySelector('x-popover');
  const sizeList = sizePop?.querySelector('.popover__value-list');
  const sizeBtnText = sizeFS?.querySelector('button.select > span[id$="selected-value"]');
  const sizeBtn     = sizeFS?.querySelector('button.select[aria-controls]');
  const colorLegendText = colorFS?.querySelector('.variant-picker__option-info .h-stack span:last-child');
  // Brand-colour description: find-or-create the italic line under the colour name and set its text.
  // Find-or-create makes it resilient to render/caching timing — if the server line is missing,
  // JS builds it; if present, JS just refreshes its text.
  function setColorDesc(desc) {
    if (!colorFS) return;
    desc = (desc || '').trim();
    let el = colorFS.querySelector('.jn-color-desc');
    // Non-Journelle products carry no brand-colour lexicon: no data-desc, so never create the line.
    if (!el && desc === '') return;
    if (!el) {
      const info = colorFS.querySelector('.variant-picker__option-info');
      if (!info) return;
      el = document.createElement('p');
      el.className = 'jn-color-desc';
      el.appendChild(document.createElement('em'));
      info.insertAdjacentElement('afterend', el);
    }
    (el.querySelector('em') || el).textContent = desc;
    el.hidden = desc === '';
  }
  const sizeBlocks = sizeFS?.querySelector('fieldset.type-block div.variant-picker__option-values'); // for blocks
  

  const initialVariantJSON = (() => { try { return JSON.parse(picker.querySelector('script[data-variant]')?.textContent||'null'); } catch { return null; } })();

  function currentHandle() {
    try {
      const parts = location.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      if (i >= 0 && parts[i+1]) return parts[i+1];
    } catch {}
    return picker.getAttribute('handle') || null;
  }
  let activeHandle = currentHandle();

  // ---------- product.js cache ----------
  const CACHE = new Map();
  async function getProduct(handle){
    if (!handle) return null;
    if (CACHE.has(handle)) return CACHE.get(handle);
    const rsp = await fetch(`/products/${handle}.js`, {credentials:'same-origin'});
    if (!rsp.ok) return null;
    const json = await rsp.json(); CACHE.set(handle, json); return json;
  }

  // ---------- URL ----------
  function setURL(handle, variantId){
    if (!handle) return;
    try {
      const u = new URL(location.href);
      u.pathname = `/products/${handle}`;
      if (variantId) u.searchParams.set('variant', String(variantId));
      else u.searchParams.delete('variant');
      history.replaceState(null, '', u.toString());
    } catch {}
  }

  // -- multi-currency price helpers
  // --- Derive pattern from a server-rendered price node
  let __pat;
  const formatCents = (c, trim=true) => {
    __pat ||= (() => {
      const n = document.querySelector('sale-price'); // probe once
      if (!n) return { pre:'', suf:'', dec:'.' };
      const x = n.cloneNode(true);
      x.querySelectorAll('.sr-only,.visually-hidden').forEach(e=>e.remove());
      const t = x.textContent.trim();
      const m = t.match(/^(.*?)([\d.,\u00A0\u202F\s]+)(.*?)$/) || [, '', '', ''];
      const dec = (m[2].match(/([.,])\d{1,3}\s*$/)||[])[1] || '.';
      return { pre:m[1], suf:m[3], dec };
    })();
    const v = Math.abs(c||0)/100, neg = (c||0) < 0;
    const fd = trim && Math.round(v*100)%100===0 ? 0 : 2;
    const num = new Intl.NumberFormat(__pat.dec===',' ? 'de-DE' : 'en-US',
      { minimumFractionDigits: fd, maximumFractionDigits: fd }).format(v);
    return (neg?'-':'') + __pat.pre + num + __pat.suf;
  };

  // ---------- IDs / price / ATC / events ----------
  function updateAllIdInputs(variantId) {
    qsa(`input[name="id"]`, SCOPE).forEach(inp => {
      inp.value = String(variantId);
      inp.dispatchEvent(new Event('input',{bubbles:true}));
      inp.dispatchEvent(new Event('change',{bubbles:true}));
    });
    const ptForm  = document.getElementById(`${formId}-payment-installment`);
    const ptInput = ptForm?.querySelector('input[name="id"]');
    if (ptInput) ptInput.value = String(variantId);
    qsa('shopify-payment-terms', SCOPE).forEach(el => el.setAttribute('variant-id', String(variantId)));
    try { Shopify?.PaymentButton?.init?.(); } catch {}
  }
  // Replace an element's price text while preserving its accessible (.sr-only) label.
  function setPriceText(el, txt){
    if (!el) return;
    const sr = el.querySelector('.sr-only');
    el.textContent = '';
    if (sr) el.appendChild(sr);
    el.appendChild(document.createTextNode(txt));
  }
  function setPriceAndATC(variant){
    // Show the strike-through compare-at price ONLY when the variant is actually on sale
    // (compare_at_price > price). Toggle the sale-price colour class to match the server render,
    // and create/remove the <compare-at-price> element so switching colours updates it correctly.
    const onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
    if (priceNode) {
      setPriceText(priceNode, formatCents(variant.price));
      priceNode.classList.toggle('text-on-sale', onSale);
      priceNode.classList.toggle('text-subdued', !onSale);
    }
    if (priceListEl) {
      let cmp = priceListEl.querySelector('compare-at-price');
      if (onSale) {
        if (!cmp) {
          cmp = document.createElement('compare-at-price');
          cmp.className = 'h5 text-subdued line-through';
          (priceNode || priceListEl).insertAdjacentElement('afterend', cmp);
        }
        setPriceText(cmp, formatCents(variant.compare_at_price));
        cmp.hidden = false;
        cmp.style.removeProperty('display');
      } else if (cmp) {
        cmp.remove();
      }
    }

    if (atcBtn) {
      const ok = !!variant.available;
      atcBtn.disabled = !ok;
      atcBtn.setAttribute('aria-disabled', ok ? 'false' : 'true');

      const labelEl = atcBtn.querySelector('[data-button-text]') || atcBtn;

      // Pull canonical texts from data-attributes if present; otherwise sane fallbacks
      const addText     = atcBtn.getAttribute('data-add-text')
                      || atcBtn.dataset.addText
                      || 'Add to cart';
      const soldOutText = atcBtn.getAttribute('data-sold-out-text')
                      || atcBtn.dataset.soldOutText
                      || 'Sold out';

      // Do NOT save current text as the default—use the stable strings above
      labelEl.textContent = ok ? addText : soldOutText;
    }
  }

  function dispatchVariantChange(variant){
    const evt = new CustomEvent('variant:change', {bubbles:true, detail:{variant}});
    picker.dispatchEvent(evt); form.dispatchEvent(evt); buyButtons?.dispatchEvent(evt);
  }
  function updateVariantScript(variant){
    const script = picker.querySelector('script[data-variant][type="application/json"]'); if (!script) return;
    try { script.textContent = JSON.stringify({ ...variant, selling_plan_allocations: variant.selling_plan_allocations || [], quantity_rule: variant.quantity_rule || {min:1,max:null,increment:1} }); } catch {}
  }
  function applyVariant(product, variant, {updateUrl=true, track = false} = {}) {
    if (!variant) return;
    // ── Immediate: update what the user sees in this frame ──
    const rawSize = variantSize(product, variant);
    if (sizeBtnText) sizeBtnText.textContent = displaySize(rawSize);
    if (sizeBtn) sizeBtn.setAttribute('data-selected-label', displaySize(rawSize));
    setPriceAndATC(variant);
    // Write form ID value synchronously so a rapid ATC tap submits the correct variant
    qsa('input[name="id"]', SCOPE).forEach(inp => { inp.value = String(variant.id); });
    const _ptInput = document.getElementById(`${formId}-payment-installment`)?.querySelector('input[name="id"]');
    if (_ptInput) _ptInput.value = String(variant.id);
    // ── Deferred: theme event propagation — runs after browser has painted ──
    setTimeout(() => {
      updateAllIdInputs(variant.id);
      updateVariantScript(variant);
      if (updateUrl) setURL(product.handle || activeHandle, variant.id);
      dispatchVariantChange(variant);
      try { if(track) { window.JRNL.fireVariantView(product, variant); } } catch(e) {}
      // Wishlist heart is product-level (custom wishlist) — no per-variant sync needed.
    }, 0);
  }

  // ---------- gallery ----------
  // video = the object you pasted in the question
  function createVideoMediaFromShopify(video) {
    const altText   = video.alt || '';
    const ratio     = video.aspect_ratio || video.preview_image.aspect_ratio || 1;
    const posterSrc = video.preview_image.src.replace(
      /\.jpg(\?[^?]*)?$/,
      '_400x.jpg$1'   // make 400px poster variant
    );

    // pick the highest-res mp4 source
    const mp4Source = (video.sources || [])
      .filter(s => s.format === 'mp4')
      .sort((a, b) => (b.height || 0) - (a.height || 0))[0];

    // -------- <video-media> wrapper --------
    const videoMedia = document.createElement('video-media');
    videoMedia.setAttribute('type', 'video');
    videoMedia.setAttribute('show-play-button', '');
    videoMedia.setAttribute('group', 'product');
    videoMedia.style.setProperty('--aspect-ratio', ratio);
    videoMedia.style.setProperty('--play-button-background', '#f6f6f6');

    // -------- <img> (thumbnail) --------
    const img = document.createElement('img');
    img.src    = video.preview_image.src;
    img.alt    = altText;
    img.width  = video.preview_image.width;
    img.height = video.preview_image.height;

    // optional: build a srcset like Shopify's
    const widths = [200, 300, 400, 500, 600, 700, 800, 1000];
    const urlObj = new URL(video.preview_image.src);
    img.srcset = widths.map(w => {
      urlObj.searchParams.set('width', w);
      return `${urlObj.toString()} ${w}w`;
    }).join(', ');
    img.sizes =
      '(max-width: 699px) calc(100vw - 40px), ' +
      '(max-width: 999px) calc(100vw - 64px), ' +
      'min(1100px, 756px - 96px)';

    // -------- <video> + <source> + fallback <img> --------
    const vid = document.createElement('video');
    vid.setAttribute('playsinline', 'true');
    vid.setAttribute('controls', 'controls');
    vid.setAttribute('loop', 'loop');
    vid.setAttribute('preload', 'metadata');
    vid.setAttribute('aria-label', altText || 'Product video');
    vid.setAttribute('poster', posterSrc);

    if (mp4Source) {
      const source = document.createElement('source');
      source.src  = mp4Source.url;
      source.type = mp4Source.mime_type || 'video/mp4';
      vid.appendChild(source);
    }

    // image fallback inside <video>
    const fallbackImg = document.createElement('img');
    fallbackImg.src = posterSrc;
    vid.appendChild(fallbackImg);

    // -------- assemble --------
    videoMedia.appendChild(img);
    videoMedia.appendChild(vid);

    return videoMedia;
  }

  function grefs() {
    const root    = qs('product-gallery.product-gallery', SCOPE);
    const imgList = root?.querySelector('.product-gallery__image-list');
    const contents= imgList?.querySelector('.contents');
    const carousel= contents?.querySelector('scroll-carousel.product-gallery__carousel');
    const sticky  = root?.querySelector('safe-sticky.product-gallery__thumbnail-list');
    const nav     = sticky?.querySelector('product-gallery-navigation');
    const mnav    = root?.querySelector('carousel-navigation');
    return { root, imgList, contents, carousel, sticky, nav, mnav };
  }
  function ensureCarousel() {
    const { root, imgList, contents, carousel } = grefs(); if (!root) return null;
    let il=imgList, ct=contents, cr=carousel;
    if (!il) { il=document.createElement('div'); il.className='product-gallery__image-list'; root.insertBefore(il, root.firstChild); }
    if (!ct) { ct=document.createElement('div'); ct.className='contents'; il.appendChild(ct); }
    if (!cr) { cr=document.createElement('scroll-carousel'); cr.className='product-gallery__carousel scroll-area full-bleed md:unbleed'; cr.id = cr.id || ('pgc-'+Math.random().toString(36).slice(2)); ct.appendChild(cr); }
    return cr;
  }
  function ensureThumbNav() {
    const { root, imgList, sticky, nav } = grefs(); if (!root) return null;
    let st=sticky, n=nav;
    if (!st) { st=document.createElement('safe-sticky'); st.className='product-gallery__thumbnail-list hidden md:block'; (imgList?.parentNode||root).insertBefore(st, imgList?.nextSibling||null); }
    if (!n)  { n=document.createElement('product-gallery-navigation'); n.className='product-gallery__thumbnail-scroller bleed md:unbleed'; st.appendChild(n); }
    const cr = grefs().carousel; if (cr?.id && !n.hasAttribute('aria-controls')) n.setAttribute('aria-controls', cr.id);
    return n;
  }
  function ensureDots() {
    const { root, imgList, sticky, mnav } = grefs(); if (!root) return null;
    let m=mnav;
    if (!m)  { m=document.createElement('carousel-navigation'); m.className='page-dots align-self-center md:hidden'; root.appendChild(m); }
    const cr = grefs().carousel; if (cr?.id && !m.hasAttribute('aria-controls')) m.setAttribute('aria-controls', cr.id);
    return m;
  }
  // Shared media normalisation used by both the fast primary swap and the full rebuild.
  function computeMedia(product) {
    return (Array.isArray(product.media) && product.media.length)
      ? product.media.map(m => ({src:(m.preview_image?.src)||m.src, alt:(hasScene7(m)? product.vendor + ' ' + product.title : m.alt) || product.vendor + ' ' + product.title || '',type:m.media_type, msrc:(m.media_type==="video"?m:null)}))
      : (Array.isArray(product.images) ? product.images.map(src => ({src:String(src).replace(/^\/\//,'https://'), alt:product.title||''})) : []);
  }

  // Fix 3: swap ONLY the first (visible) slide's image in place so a colour change shows
  // the new main image in the current frame, without rebuilding the whole gallery.
  function renderGalleryPrimary(product) {
    const { carousel } = grefs();
    if (!carousel) return;
    const first = computeMedia(product)[0];
    if (!first || first.type === 'video') return; // videos handled by the full rebuild
    const img = carousel.querySelector('.product-gallery__media img');
    if (!img) return;
    img.src = withW(first.src, 1000);
    img.srcset = srcset(first.src);
    img.alt = first.alt;
    img.setAttribute('loading', 'eager');
    img.setAttribute('fetchpriority', 'high');
    try { carousel.scrollTo({ left: 0, behavior: 'auto' }); } catch {}
  }

  function renderGallery(product) {
    const cr = ensureCarousel(); if (!cr) return;
    if (BOOTING && cr.querySelector('.product-gallery__media')) {
      BOOTING = false;
      return; // don't on initial load
    }
    const media = computeMedia(product);
    if (!media.length) return;
    cr.innerHTML = media.map(function(m,i) {
      if(m.type ==="video" && m.msrc != null) {
        const node = createVideoMediaFromShopify(m.msrc);
        return `<div class="product-gallery__media snap-center${i===0?' is-initial':''}" data-media-type="image" role="group" aria-label="Item ${i+1} of ${media.length}">
          ${node.outerHTML}
        </div>` ;        
      } else {
        return `<div class="product-gallery__media snap-center${i===0?' is-initial':''}" data-media-type="image" role="group" aria-label="Item ${i+1} of ${media.length}">
          <img src="${withW(m.src,1000)}" alt="${m.alt}" srcset="${srcset(m.src)}" width="1000" height="1250" ${i===0?'loading="eager" fetchpriority="high"':'loading="lazy"'}
              sizes="${GALLERY_SIZES}">
        </div>` ;
      }
    }).join('');
    // Re-wire the IntersectionObserver to the new slide elements
    if (slideObserver) {
      slideObserver.disconnect();
      qsa('.product-gallery__media', cr).forEach(el => slideObserver.observe(el));
    }
    const nav = ensureThumbNav();
    if (nav) {
      nav.innerHTML = media.map(function(m,i) { 
        return `<button type="button" class="product-gallery__thumbnail" data-media-type="${m.type}" data-media-position="${i+1}" aria-current="${i===0?'true':'false'}" aria-label="Go to item ${i+1}">
          <img src="${withW(m.src,1000)}" alt="${m.alt}" srcset="${srcset(m.src,[56,112,168])}" width="1000" height="1250" sizes="56px" class="object-contain">` + 
            (m.type === "video" ? `<div class="product-gallery__media-badge"><svg focusable="false" width="12" viewBox="0 0 26 26" fill="none" role="presentation">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z" fill="#f6f6f6"></path>
      <path d="M.5 25v.5h25V.5H.5V25z" stroke="#57595b" stroke-opacity=".15"></path>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 00-1.518.855v10.736a1 1 0 001.562.827l8.35-5.677a1 1 0 00-.044-1.682l-8.35-5.06z" fill="#57595b" fill-opacity=".6"></path>
    </svg></div>`:``) +  `</button>`}).join('');
    }
    const mnav = ensureDots();
    if(mnav) {
      mnav.innerHTML = media.map(function(m,i) { 
          return `
            <button type="button" class="tap-area" data-media-position="${i+1}" aria-current="${i===0?'true':'false'}">
              <span class="sr-only">Go to item ${i+1}</span>
            </button>`;
      }).join('');
    }
    wireGalleryInteractions(); // (re)bind clicks after (re)render
    wireDotGalleryInteractions(); // (re)bind clicks after (re)render
    BOOTING = false;
  }

  // thumbnails → scroll gallery (scoped)
  function wireGalleryInteractions() {
    const { carousel, nav } = grefs();
    if (!carousel || !nav || nav.dataset.wired === '1') return;
    nav.dataset.wired = '1';
    nav.addEventListener('click', (e) => {
      if (!IN_SCOPE(e.target)) return;
      const btn = e.target.closest?.('.product-gallery__thumbnail');
      if (!btn) return;
      e.preventDefault();
      const pos = Number(btn.getAttribute('data-media-position')) || 1;
      const items = qsa('.product-gallery__media', carousel);
      const idx = Math.max(0, Math.min(items.length - 1, pos - 1));
      const target = items[idx];
      if (!target) return;
      try { target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
      catch { const left = target.offsetLeft - (carousel.clientWidth - target.clientWidth) / 2; carousel.scrollTo({ left, behavior: 'smooth' }); }
      qsa('.product-gallery__thumbnail[aria-current="true"]', nav).forEach(b => b.setAttribute('aria-current','false'));
      btn.setAttribute('aria-current','true');
    }, true);
  }
  function wireDotGalleryInteractions() {
    const { carousel, mnav } = grefs();
    const nav = mnav;

    if (!carousel || !nav || nav.dataset.wired === '1') return;
    nav.dataset.wired = '1';

    // carousel is your <scroll-carousel> with .product-gallery__carousel
    const getDots  = () => Array.from(nav.querySelectorAll('.tap-area'));
    const getItems = () => Array.from(carousel.querySelectorAll('.product-gallery__media'));

    function setActiveDot(idx) {
      const dots = getDots();
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    // -------------------------
    // Click on dots -> scroll carousel
    // -------------------------
    nav.addEventListener(
      'click',
      (e) => {
        if (!IN_SCOPE(e.target)) return; // keep this if you need the scope filter
        const btn = e.target.closest?.('.tap-area');
        if (!btn) return;

        e.preventDefault();

        // your HTML has data-media-position="1..6"
        const pos = Number(btn.getAttribute('data-media-position')) || 1;
        const items = getItems();
        const idx = Math.max(0, Math.min(items.length - 1, pos - 1));
        const target = items[idx];
        if (!target) return;

        try {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        } catch {
          const left =
            target.offsetLeft - (carousel.clientWidth - target.clientWidth) / 2;
          carousel.scrollTo({ left, behavior: 'smooth' });
        }

        setActiveDot(idx);
      },
      true
    );

    // Track the centered slide with IntersectionObserver — no layout forcing, no polling
    slideObserver = new IntersectionObserver((entries) => {
      let best = null;
      for (const e of entries) {
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        }
      }
      if (best) {
        const idx = getItems().indexOf(best.target);
        if (idx !== -1) setActiveDot(idx);
      }
    }, { root: carousel, threshold: 0.5 });
    qsa('.product-gallery__media', carousel).forEach(el => slideObserver.observe(el));
  }


  // ---------- option-order helpers (size may be option1 OR option2, in any order) ----------
  // product.options from /products/handle.js can be an array of strings OR of {name,values}
  // objects depending on Shopify version — handle both. variant.option1/2/3 and variant.options[]
  // always exist regardless of that shape.
  function jnOptName(o){ return typeof o === 'string' ? o : (o && o.name) || ''; }
  function sizeOptionIndex(product){
    const opts = (product && product.options) || [];
    for (let i = 0; i < opts.length; i++){ if (/size/i.test(jnOptName(opts[i]))) return i; }
    // 2-option fallback: whichever option is NOT the colour option is the size option
    if (opts.length === 2){
      for (let j = 0; j < 2; j++){ if (/colou?r|couleur|colore/i.test(jnOptName(opts[j]))) return 1 - j; }
    }
    return 0;
  }
  function variantSize(product, variant){
    if (!variant) return '';
    const i = sizeOptionIndex(product);
    if (Array.isArray(variant.options) && variant.options.length > i) return variant.options[i];
    return variant['option' + (i + 1)] || variant.title || '';
  }

  // ---------- size ordering ----------
  function sizeOrderMapFromProduct(product){
    const map = new Map();
    const opts = (product && product.options) || [];
    const opt = opts[sizeOptionIndex(product)];
    if (opt && Array.isArray(opt.values)) {
      opt.values.forEach((v,i) => map.set(String(v).toLowerCase().trim(), i));
    } else {
      // strings shape (no per-option values): derive first-seen order from variants
      let i = 0;
      ((product && product.variants) || []).forEach(v => {
        const key = String(variantSize(product, v)).toLowerCase().trim();
        if (!map.has(key)) map.set(key, i++);
      });
    }
    return map;
  }

  const SIZE_ABBR = new Map([
    ['extra extra small', 'XXS'],
    ['xxs',               'XXS'],
    ['extra small',       'XS'],
    ['xs',                'XS'],
    ['petite',             'P'],
    ['small',             'S'],
    ['s',                 'S'],
    ['medium',            'M'],
    ['m',                 'M'],
    ['large',             'L'],
    ['l',                 'L'],
    ['extra large',       'XL'],
    ['xl',                'XL'],
    ['extra extra large', 'XXL'],
    ['xxl',               'XXL'],
    ['1x',                '1X'],
    ['2xl',               '2XL'],
    ['2x',                '2X'],
    ['3xl',               '3XL'],
    ['3x',                '3X'],
    ['one size',          'OS'],
    ['os',                'OS']
  ]);

  const displaySize = (name) => {
    const key = String(name || '').toLowerCase().trim();
    return SIZE_ABBR.get(key) || name;
  };


  const apparelRank = new Map([
    ['xxs',0], ['xs/s',0], ['extra extra small',0], ['xs',1], ['extra small',1],
    ['p',1], ['petite',1],
    ['s',2],   ['small',2], ['s/m',2], ['m',3], ['medium',3], ['m/l',3],
    ['l',4], ['l/xl',4],   ['large',4], ['xl',5], ['extra large',5],
    ['xxl',6],['1x',6], ['2xl',6], ['extra extra large',6],['2x',6], ['xxxl',7], ['3xl',7],['3x',7], ['one size',50], ['os',50]
  ]);

  // ---------- BRA HELPERS ----------
  const CUP_ORDER = ['aa','a','b','c','d','dd','e','f','ff','g','gg','h','hh','i','j','k'];

  function normalizeCup(raw) {
    // strip spaces/slashes/dashes
    let c = String(raw).toLowerCase().replace(/[\s\-\/]+/g,'');
    // common aliases
    if (c === 'ddd') c = 'f';
    if (c === 'eeee') c = 'ff';
    if (c === 'eee') c = 'f';
    return c;
  }

  function parseBraSize(s) {
    const str = String(s).trim();
    // "30D", "30 D", "30-DD", "30DDD", "30 DDD"
    let m = str.match(/^(\d{2,3})\s*[-\s]*([A-Za-z]{1,4})$/);
    if (!m) return { isBra:false, band:Infinity, cup:'zzz', raw:str };
    const band = Number(m[1]);
    const cup  = normalizeCup(m[2]);
    return { isBra:true, band, cup, raw:str };
  }
 
  function sortBraSizesInPlace(items, getName = x => x.name ?? x) {
    return items.sort((x,y) => {
      const A = parseBraSize(getName(x));
      const B = parseBraSize(getName(y));
      if (A.band !== B.band) return A.band - B.band;
      const ia = CUP_ORDER.indexOf(A.cup), ib = CUP_ORDER.indexOf(B.cup);
      if (ia !== -1 && ib !== -1 && ia !== ib) return ia - ib;
      // fallback natural compare
      return String(getName(x)).localeCompare(String(getName(y)), undefined, {numeric:true, sensitivity:'base'});
    });
  }
  // ---------- END BRA HELPERS ----------

  function sortSizes(product, sizes) {
    const getName = s => String(s?.name ?? s);
    const values  = sizes.map(getName);

    // 1) Bra-first logic stays the same
    const braCount = values.filter(v => parseBraSize(v).isBra).length;
    const isBraish = braCount >= Math.ceil(values.length * 0.6);
    if (isBraish) {
      return sortBraSizesInPlace(sizes, s => getName(s));
    }

    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    // 2) Prefer generic apparelRank
    const rankA = name => apparelRank.get(name.toLowerCase().trim());
    const allHaveApparelRank = values.every(v => rankA(v) != null);

    if (allHaveApparelRank) {
      // Use apparelRank primarily
      return sizes.sort((a, b) => {
        const A = rankA(getName(a));
        const B = rankA(getName(b));
        if (A != null && B != null) return A - B;
        if (A != null) return -1;
        if (B != null) return 1;
        return collator.compare(getName(a), getName(b));
      });
    }

    // 2b) All numeric sizes — sort numerically, don't trust Shopify option order
    const allNumeric = values.every(v => v.trim() !== '' && isFinite(Number(v.trim())));
    if (allNumeric) {
      return sizes.sort((a, b) => Number(getName(a)) - Number(getName(b)));
    }

    // 3) Fall back to product-defined order if apparelRank wasn't sufficient
    const productOrder = sizeOrderMapFromProduct(product); // assumed Map(name->index)
    if (productOrder && productOrder.size) {
      const rankP = name => productOrder.get(name.toLowerCase().trim());
      return sizes.sort((a, b) => {
        const A = rankP(getName(a));
        const B = rankP(getName(b));
        if (A != null && B != null) return A - B;
        if (A != null) return -1;
        if (B != null) return 1;
        // final tie-breaker: apparelRank if present, else alpha
        const aA = rankA(getName(a));
        const bA = rankA(getName(b));
        if (aA != null && bA != null) return aA - bA;
        if (aA != null) return -1;
        if (bA != null) return 1;
        return collator.compare(getName(a), getName(b));
      });
    }

    // 4) Last resort: partial apparelRank then alpha
    return sizes.sort((a, b) => {
      const A = rankA(getName(a));
      const B = rankA(getName(b));
      if (A != null && B != null) return A - B;
      if (A != null) return -1;
      if (B != null) return 1;
      return collator.compare(getName(a), getName(b));
    });
  }


  // ---------- render sizes ----------
  const SIZE_FITS = JSON.parse(
    document.getElementById('size-fits-json')?.textContent || '{}'
  );

  const PANTY_NORM_PDP = {
    'EXTRA SMALL':'XS','X-SMALL':'XS','X SMALL':'XS','SMALL':'S',
    'MEDIUM':'M','LARGE':'L','EXTRA LARGE':'XL','X-LARGE':'XL',
    'EXTRA EXTRA LARGE':'XXL','2XL':'XXL','3XL':'XXXL',
    'ONE SIZE':'OS','ONE SIZE FITS ALL':'OS','OSFM':'OS',
  };
  const PANTY_CANONICAL_PDP = new Set(['XS','S','M','L','XL','XXL','XXXL','OS']);
  function normPantySizePDP(s) {
    const u = (s || '').trim().toUpperCase();
    return PANTY_NORM_PDP[u] || (PANTY_CANONICAL_PDP.has(u) ? u : null);
  }

  function findFitVariant(product) {
    let braSize = null;
    try { braSize = JSON.parse(getCookieVal('jfq_bra_sz') || 'null'); } catch {}
    if (!braSize?.band || !braSize?.cup) {
      // No bra size — try panty size
      let dressData = null;
      try { dressData = JSON.parse(getCookieVal('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz') || 'null'); } catch {}
      const pantySize = dressData?.pantySize;
      if (!pantySize) return null;
      const dressSize = typeof dressData?.dressSize === 'number' ? dressData.dressSize : null;

      // Primary: match dress size number against custom.fits ranges in SIZE_FITS
      if (dressSize != null && Object.keys(SIZE_FITS).length) {
        for (const [sizeName, fitsText] of Object.entries(SIZE_FITS)) {
          if (!fitsText) continue;
          const inRange = fitsText.split(',').some(part => {
            const m = /^(\d+)\s*[-–]\s*(\d+)$/.exec(part.trim());
            return m && dressSize >= parseInt(m[1], 10) && dressSize <= parseInt(m[2], 10);
          });
          if (inRange) {
            const v = product.variants.find(v => v.available && variantSize(product, v) === sizeName);
            if (v) { fromPantyCookiePreset = true; return v.id; }
          }
        }
      }

      // Fallback: scan all variant options for a direct letter-size match
      const ps = pantySize.toUpperCase();
      const v = product.variants.find(v => v.available &&
        [v.option1, v.option2, v.option3].some(o => normPantySizePDP(o) === ps));
      if (v) { fromPantyCookiePreset = true; return v.id; }
      return null;
    }

    const band = String(braSize.band);
    const cup = braSize.cup.toUpperCase();
    const CUP_ALIASES = { 'DD':['DD','E','DD/E'], 'E':['DD','E','DD/E'], 'DDD':['DDD','F','DDD/F'], 'F':['DDD','F','DDD/F'] };
    const cupForms = CUP_ALIASES[cup] || [cup];
    const sizeForms = cupForms.map(c => (band + c).toUpperCase());

    // First: check SIZE_FITS (clothing-sized products where each size covers bra fit ranges)
    if (Object.keys(SIZE_FITS).length) {
      for (const [sizeName, fitsText] of Object.entries(SIZE_FITS)) {
        if (!fitsText) continue;
        const entries = fitsText.split(',').map(s => s.trim().toUpperCase());
        if (sizeForms.some(sz => entries.includes(sz))) {
          const v = product.variants.find(v => variantSize(product, v) === sizeName && v.available);
          if (v) return v.id;
        }
      }
    }

    // Fallback: match variant size option directly (bra-sized products like "34DD/E")
    for (const v of product.variants) {
      if (!v.available) continue;
      const vSize = variantSize(product, v).toUpperCase().trim();
      if (sizeForms.includes(vSize)) return v.id;
    }

    // Bra size didn't match — try panty size only for actual panty products.
    // Guard: if SIZE_FITS contains bra-size entries (e.g. "30C, 32DD") or the
    // product type contains "bra", this is a bra/bralette — skip the fallback.
    // Without this guard, DDD cups that aren't in the fits chart fall through and
    // incorrectly match the panty cookie (L/XL), causing wrong size + wrong modal.
    {
      const fitsHasBraSizes = Object.values(SIZE_FITS).some(fits =>
        fits && fits.split(',').some(s => parseBraSize(s.trim()).isBra)
      );
      const isLikelyBra = /bra/i.test(product.type || '');
      if (!fitsHasBraSizes && !isLikelyBra) {
        let dressData2 = null;
        try { dressData2 = JSON.parse(getCookieVal('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz') || 'null'); } catch {}
        const pantySize2 = dressData2?.pantySize;
        if (pantySize2) {
          const ps = pantySize2.toUpperCase();
          const pv = product.variants.find(v => v.available &&
            [v.option1, v.option2, v.option3].some(o => normPantySizePDP(o) === ps));
          if (pv) { fromPantyCookiePreset = true; return pv.id; }
        }
      }
    }

    return null;
  }

  //let lastChosenSize = (initialVariantJSON?.option1 || initialVariantJSON?.title || '').trim();
  let lastChosenSize = urlVariant ? (initialVariantJSON?.option1 || initialVariantJSON?.title || '').trim() : '';

  // ---------- BRA PICKER (band × cup) ----------
  function renderBraSizes(product, selectedVariantId, {trackOnSelect = false} = {}) {
    if (!sizeFS) return;

    const sizeOptIdx = sizeOptionIndex(product);
    const sizeKey = 'option' + (sizeOptIdx + 1);

    // Build band → cup → variant map
    const bandVariants = new Map(); // band(number) → Map(cupNorm → variant)
    const cupDisplay   = new Map(); // cupNorm → display string

    for (const v of product.variants) {
      const raw = (v[sizeKey] || v.title).trim();
      const p   = parseBraSize(raw);
      if (!p.isBra) continue;
      if (!bandVariants.has(p.band)) bandVariants.set(p.band, new Map());
      bandVariants.get(p.band).set(p.cup, v);
      if (!cupDisplay.has(p.cup))
        cupDisplay.set(p.cup, raw.replace(/^\d{2,3}\s*[-\s]*/,'').trim().toUpperCase());
    }

    const allBands = [...bandVariants.keys()].sort((a,b) => a - b);
    const allCups  = [...cupDisplay.keys()].sort((a,b) => {
      const ia = CUP_ORDER.indexOf(a), ib = CUP_ORDER.indexOf(b);
      return ia !== -1 && ib !== -1 ? ia - ib : 0;
    });
    if (!allBands.length || !allCups.length) return;

    // Determine initial band + cup
    let selBand = null, selCup = null;
    const parseBC = v => {
      if (!v) return null;
      const p = parseBraSize(v[sizeKey] || v.title);
      return p.isBra ? {band: p.band, cup: p.cup} : null;
    };
    const lastBC = lastChosenSize ? (() => {
      const p = parseBraSize(lastChosenSize);
      return p.isBra ? { band: p.band, cup: p.cup } : null;
    })() : null;
    const bc = parseBC(product.variants.find(v => v.id === selectedVariantId)) || lastBC;
    if (bc) { selBand = bc.band; selCup = bc.cup; }
    if (selBand == null) selBand = allBands[0];
    if (selCup == null) {
      selCup = allCups.find(c => bandVariants.get(selBand)?.get(c)?.available)
             || allCups.find(c => bandVariants.get(selBand)?.has(c))
             || allCups[0];
    }

    // Create or reuse the container (persists across color-change re-renders)
    let braContainer = sizeFS.querySelector('.jn-bra-picker');
    if (!braContainer) {
      braContainer = document.createElement('div');
      braContainer.className = 'jn-bra-picker';

      // Hide the underlying block buttons or dropdown
      const toHide = sizeBlocks || sizePop?.closest('.relative') || sizePop;
      if (toHide) { toHide.style.display = 'none'; toHide.dataset.jnHidden = '1'; }

      const optInfo = sizeFS.querySelector('.variant-picker__option-info');
      if (optInfo) optInfo.insertAdjacentElement('afterend', braContainer);
      else sizeFS.appendChild(braContainer);

      if (!document.getElementById('jn-bra-style')) {
        const s = document.createElement('style');
        s.id = 'jn-bra-style';
        s.textContent = [
          '.jn-bra-picker{display:flex;flex-direction:column;gap:12px;margin-top:4px}',
          '.jn-bra-row{display:flex;flex-direction:column;gap:6px}',
          '.jn-bra-row__label{font-size:11px;letter-spacing:.06em;text-transform:uppercase;opacity:.6}',
          '.jn-bra-row__options{display:flex;flex-wrap:wrap;gap:6px}',
          '.block-swatch.jn-unavailable{opacity:.2;pointer-events:none}',
          '.jn-bra-picker .block-swatch.is-disabled{pointer-events:auto!important;cursor:pointer}',
        ].join('');
        document.head.appendChild(s);
      }
    } else {
      braContainer.innerHTML = '';
    }

    const idPrefix = `jn-bra-${formId}`;

    // Band row
    const bandRow = document.createElement('div');
    bandRow.className = 'jn-bra-row';
    const bandRowLabel = document.createElement('div');
    bandRowLabel.className = 'jn-bra-row__label';
    bandRowLabel.textContent = 'Band';
    const bandOptions = document.createElement('div');
    bandOptions.className = 'jn-bra-row__options';

    for (const band of allBands) {
      const id  = `${idPrefix}-band-${band}`;
      const inp = document.createElement('input');
      inp.type = 'radio'; inp.className = 'sr-only';
      inp.id = id; inp.name = `${idPrefix}-band`; inp.value = String(band);
      const lbl = document.createElement('label');
      lbl.className = 'block-swatch'; lbl.setAttribute('for', id);
      lbl.dataset.band = String(band); lbl.textContent = String(band);
      inp.addEventListener('change', () => {
        if (quizNoteEl) { quizNoteEl.remove(); quizNoteEl = null; }
        userChoseBraSize = true;
        const cupMap = bandVariants.get(band);
        let targetCup = selCup;
        if (!cupMap?.has(targetCup))
          targetCup = allCups.find(c => cupMap?.get(c)?.available)
                   || allCups.find(c => cupMap?.has(c))
                   || selCup;
        update(band, targetCup);
      });
      bandOptions.append(inp, lbl);
    }
    bandRow.append(bandRowLabel, bandOptions);

    // Cup row
    const cupRow = document.createElement('div');
    cupRow.className = 'jn-bra-row';
    const cupRowLabel = document.createElement('div');
    cupRowLabel.className = 'jn-bra-row__label';
    cupRowLabel.textContent = 'Cup';
    const cupOptions = document.createElement('div');
    cupOptions.className = 'jn-bra-row__options';

    for (const cupNorm of allCups) {
      const displayName = cupDisplay.get(cupNorm) || cupNorm.toUpperCase();
      const id  = `${idPrefix}-cup-${cupNorm}`;
      const inp = document.createElement('input');
      inp.type = 'radio'; inp.className = 'sr-only';
      inp.id = id; inp.name = `${idPrefix}-cup`; inp.value = cupNorm;
      const lbl = document.createElement('label');
      lbl.className = 'block-swatch'; lbl.setAttribute('for', id);
      lbl.dataset.cup = cupNorm; lbl.textContent = displayName;
      inp.addEventListener('change', () => {
        if (quizNoteEl) { quizNoteEl.remove(); quizNoteEl = null; }
        userChoseBraSize = true;
        update(selBand, cupNorm);
      });
      cupOptions.append(inp, lbl);
    }
    cupRow.append(cupRowLabel, cupOptions);
    braContainer.append(bandRow, cupRow);

    function update(band, cup) {
      selBand = band; selCup = cup;

      for (const lbl of bandOptions.querySelectorAll('label')) {
        const b      = Number(lbl.dataset.band);
        const inp    = document.getElementById(`${idPrefix}-band-${b}`);
        const cupMap = bandVariants.get(b);
        const anyAvail = cupMap && [...cupMap.values()].some(v => v.available);
        lbl.className = anyAvail ? 'block-swatch' : 'block-swatch is-disabled';
        lbl.removeAttribute('aria-disabled');
        if (inp) inp.checked = (b === band);
      }

      for (const lbl of cupOptions.querySelectorAll('label')) {
        const c   = lbl.dataset.cup;
        const inp = document.getElementById(`${idPrefix}-cup-${c}`);
        const v   = bandVariants.get(band)?.get(c);
        lbl.className = !v ? 'block-swatch jn-unavailable'
                      : !v.available ? 'block-swatch is-disabled' : 'block-swatch';
        if (!v) lbl.setAttribute('aria-disabled','true');
        else lbl.removeAttribute('aria-disabled');
        if (inp) inp.checked = (c === cup);

        let badge = lbl.querySelector('.jn-low-stock-badge');
        if (v && v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity < 3 && v.available) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'jn-low-stock-badge'; lbl.appendChild(badge); }
          badge.textContent = v.inventory_quantity + ' left';
          lbl.classList.add('jn-has-low-stock');
        } else {
          if (badge) badge.remove();
          lbl.classList.remove('jn-has-low-stock');
        }
      }

      const variant = bandVariants.get(band)?.get(cup);
      if (variant) {
        lastChosenSize = variant[sizeKey] || variant.title;
        applyVariant(product, variant, {updateUrl: true, track: !!trackOnSelect});
      }
    }

    update(selBand, selCup);
    if (sizeFS) sizeFS.classList.remove('jn-bra-loading');

    if ((fromQuiz || fromCookiePreset) && !quizNoteEl && !userChoseBraSize && sizeFS) {
      quizNoteEl = document.createElement('p');
      quizNoteEl.style.cssText = 'display:block;font-size:11px;color:rgb(89,52,109);letter-spacing:0.04em;margin-top:-10px;margin-bottom:10px;font-style:italic;opacity:0.75;';
      quizNoteEl.innerHTML = fromQuiz
        ? 'Size chosen based on your Fit Quiz — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.'
        : 'Selected for you based on your fit profile — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.';
      sizeFS.insertAdjacentElement('afterend', quizNoteEl);
    }
  }
  // ---------- END BRA PICKER ----------

  function renderSizes(product, selectedVariantId=null, {trackOnSelect = false} = {}){
    if (!sizeList && !sizeBlocks) return;

    // Detect bra products and delegate to bra picker
    const _sizeOptIdx = sizeOptionIndex(product);
    const _sizeKey = 'option' + (_sizeOptIdx + 1);
    const _braCount = product.variants.filter(v => parseBraSize(v[_sizeKey] || v.title).isBra).length;
    if (_braCount >= Math.ceil(product.variants.length * 0.6) && window.__jnBraPicker !== false) {
      renderBraSizes(product, selectedVariantId, {trackOnSelect});
      return;
    }

    // Clean up bra picker if switching away from a bra product
    const _existingBra = sizeFS?.querySelector('.jn-bra-picker');
    if (_existingBra) {
      _existingBra.remove();
      const _hidden = sizeFS?.querySelector('[data-jn-hidden="1"]');
      if (_hidden) { _hidden.style.display = ''; _hidden.removeAttribute('data-jn-hidden'); }
    }

    const sizes = product.variants.map(v => ({ name: v[_sizeKey] || v.title, id: v.id, available: !!v.available, inventory_quantity: v.inventory_quantity, inventory_management: v.inventory_management }));
    sortSizes(product, sizes);
    
    if ( sizeList ) {

      sizeList.innerHTML = '';
    
      const frag = document.createDocumentFragment();

      const placeholder = document.createElement('div');
      placeholder.className = 'popover__value-option is-placeholder';
      placeholder.setAttribute('aria-disabled', 'true');
      placeholder.style.pointerEvents = 'none';
      placeholder.style.opacity = '0.6';
      placeholder.textContent = 'Select your size';
      frag.appendChild(placeholder);

      sizes.forEach((s, i) => {
        const inputId = `pdp-size-${i+1}-${s.id}`;
        const label = document.createElement('label');
        label.className = 'popover__value-option h-stack justify-between gap-2';
        label.setAttribute('for', inputId);

        const input = document.createElement('input');
        input.className = 'sr-only';
        input.type = 'radio';
        input.id = inputId;
        input.name = `${formId}-option1-real`;
        input.dataset.variantId = String(s.id);
        input.value = s.name;

        const span = document.createElement('span');
        const fspan = document.createElement('span');
        fspan.classList = "fits";
        const fitsVal = SIZE_FITS[s.name];
        const fits = (fitsVal && fitsVal !== s.name ? ` (${fitsVal})` : "");
        fspan.textContent = fits;
        span.textContent = displaySize(s.name);

        label.append(input, span, fspan);

        if (!s.available) {
          input.disabled = true;
          label.setAttribute('aria-disabled','true');
          label.style.opacity = '0.45';
          const note = document.createElement('small');
          note.className = 'text-subdued';
          note.textContent = 'Sold out';
          label.appendChild(note);
        }

        input.addEventListener('change', () => {
          lastChosenSize = s.name;
          if (quizNoteEl) { quizNoteEl.remove(); quizNoteEl = null; }
          applyVariant(product, product.variants.find(v => v.id === s.id), {updateUrl: true, track: true});
        });

        frag.appendChild(label);
      });

      sizeList.appendChild(frag);

      const preferred =
        (selectedVariantId && product.variants.find(v => v.id === selectedVariantId)) ||
        (lastChosenSize && product.variants.find(v => (v[_sizeKey]||v.title) === lastChosenSize));

      if (preferred) {
        const chosen = qsa('input[type="radio"]', sizeList).find(inp => inp.dataset.variantId === String(preferred.id));
        if (chosen) chosen.checked = true;
        lastChosenSize = preferred[_sizeKey] || preferred.title;
        applyVariant(product, preferred, {track: !!trackOnSelect});
        if ((fromQuiz || fromCookiePreset) && !quizNoteEl && sizeFS) {
          quizNoteEl = document.createElement('p');
          quizNoteEl.style.cssText = 'display:block;font-size:11px;color:rgb(89,52,109);letter-spacing:0.04em;margin-top:-10px;margin-bottom:10px;font-style:italic;opacity:0.75;';
          if (fromPantyCookiePreset) {
            quizNoteEl.innerHTML = 'Selected for you based on your measurements — <a href="/pages/shopping-help?category=panties" onclick="event.preventDefault();window.jnOpenPantyModal&&window.jnOpenPantyModal()" style="color:inherit;text-decoration:underline;cursor:pointer">update your size</a>.';
          } else {
            quizNoteEl.innerHTML = fromQuiz
              ? 'Size chosen based on your Fit Quiz — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.'
              : 'Selected for you based on your fit profile — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.';
          }
          sizeFS.insertAdjacentElement('afterend', quizNoteEl);
        }
      } else {
        // No size chosen yet → show placeholder in the dropdown button
        if (sizeBtnText) sizeBtnText.textContent = 'Select your size';
        if (sizeBtn) sizeBtn.setAttribute('data-selected-label', '');
        // uncheck any stray radio
        qsa('input[type="radio"]', sizeList).forEach(i => i.checked = false);
        // lock ATC until a size is picked
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled','true');
          const labelEl = atcBtn.querySelector('[data-button-text]') || atcBtn;
          labelEl.textContent = 'Select a size';
        }
      }
    } else if(sizeBlocks) {

        sizeBlocks.innerHTML = '';

        const frag = document.createDocumentFragment();
        sizes.forEach((s, i) => {
          const inputId = `pdp-size-${i+1}-${s.id}`;
          const label = document.createElement('label');
          label.className = 'block-swatch';
          label.setAttribute('for', inputId);

          const input = document.createElement('input');
          input.className = 'sr-only';
          input.type = 'radio';
          input.id = inputId;
          input.name = `${formId}-option1-real`;
          input.dataset.variantId = String(s.id);
          input.value = s.name;

          const span = document.createElement('span');
          const fspan = document.createElement('span');
          fspan.classList = "fits";
          const fits = (SIZE_FITS[s.name]!==undefined && SIZE_FITS[s.name] ? ` (${SIZE_FITS[s.name]})` : "");
          fspan.textContent = '';//fits;
          span.textContent = displaySize(s.name);
          label.append(span);

          if (s.inventory_management && s.inventory_quantity > 0 && s.inventory_quantity < 3) {
            const badge = document.createElement('span');
            badge.className = 'jn-low-stock-badge';
            badge.textContent = s.inventory_quantity + ' left';
            label.append(badge);
            label.classList.add('jn-has-low-stock');
          }

          if (!s.available) {
            //input.disabled = true;
            label.className = 'block-swatch is-disabled';
            label.setAttribute('aria-disabled','true');
          }

          input.addEventListener('change', () => {
            lastChosenSize = s.name;
            if (quizNoteEl) { quizNoteEl.remove(); quizNoteEl = null; }
            applyVariant(product, product.variants.find(v => v.id === s.id), {updateUrl: true, track: true});
          });

          frag.appendChild(input);
          frag.appendChild(label);
        });

        sizeBlocks.appendChild(frag);
        const preferred =
          (selectedVariantId && product.variants.find(v => v.id === selectedVariantId)) ||
          (lastChosenSize && product.variants.find(v => (v[_sizeKey]||v.title) === lastChosenSize)) ||
          product.variants.find(v => v.available) ||                     // <-- move this up
          product.variants.find(v => v.id === (initialVariantJSON?.id)) ||// <-- now after
          product.variants[0];

        if (preferred) {
          const chosen = qsa('input[type="radio"]', sizeBlocks).find(inp => inp.dataset.variantId === String(preferred.id));
          if (chosen) chosen.checked = true;
          lastChosenSize = preferred[_sizeKey] || preferred.title;
          applyVariant(product, preferred, {track: !!trackOnSelect}); // sets URL
          if ((fromQuiz || fromCookiePreset) && !quizNoteEl && sizeFS) {
            quizNoteEl = document.createElement('p');
            quizNoteEl.style.cssText = 'display:block;font-size:11px;color:rgb(89,52,109);letter-spacing:0.04em;margin-top:-10px;margin-bottom:10px;font-style:italic;opacity:0.75;';
            if (fromPantyCookiePreset) {
              quizNoteEl.innerHTML = 'Selected for you based on your measurements — <a href="/pages/shopping-help?category=panties" onclick="event.preventDefault();window.jnOpenPantyModal&&window.jnOpenPantyModal()" style="color:inherit;text-decoration:underline;cursor:pointer">update your size</a>.';
            } else {
              quizNoteEl.innerHTML = fromQuiz
                ? 'Size chosen based on your Fit Quiz — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.'
                : 'Selected for you based on your fit profile — <a href="/pages/shopping-help?category=bras" onclick="event.preventDefault();window.jnOpenBraModal&&window.jnOpenBraModal()" style="color:inherit;text-decoration:underline;cursor:pointer">change it any time</a>.';
            }
            sizeFS.insertAdjacentElement('afterend', quizNoteEl);
          }
        }
    }
  }

  // Swap your family-products recommendations for a NEW product id (numeric)
  async function reloadFamilyProductsById(productId, { container } = {}) {
    const root = container || document;

    // Always target the recommendations element itself
    const el = root.querySelector('product-recommendations.jn-family-products');
    if (!el) return;

    // Keep section_id so Shopify renders the right markup, but don't replace the whole section
    let sectionId = el.dataset.sectionId
      || el.closest('[id^="shopify-section-"]')?.id?.replace(/^shopify-section-/, '')
      || '';

    const limit  = el.getAttribute('limit')  || '4';
    const intent = el.getAttribute('intent') || 'complementary';

    const url = `${Shopify.routes.root}recommendations/products`
      + `?product_id=${encodeURIComponent(productId)}`
      + `&limit=${encodeURIComponent(limit)}`
      + `&section_id=${encodeURIComponent(sectionId)}`
      + `&intent=${encodeURIComponent(intent)}`
      + `&_=${Date.now()}`;

    const html = await (await fetch(url, { credentials: 'same-origin' })).text();

    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Pull the fresh <product-recommendations> out of the response
    const fresh = temp.querySelector('product-recommendations.jn-family-products')
              || temp.querySelector('product-recommendations')
              || temp.firstElementChild;

    if (fresh) {
      // Replace ONLY the recommendations node so the product section (and listeners) survive
      el.replaceWith(fresh);

      // Optional: let the theme know a component updated (no full section reload)
      document.dispatchEvent(new CustomEvent('recommendations:updated', { detail: { productId } }));
    }
  }


  // ---------- swatch (color) ----------
  function handleFromSwatch(input) {
    if (!input) return '';
    if (input.dataset.handle) return input.dataset.handle;
    if (input.dataset.url) {
      try {
        const u = new URL(input.dataset.url, location.origin);
        const parts = u.pathname.split('/').filter(Boolean);
        const i = parts.indexOf('products');

        if (i >= 0 && parts[i + 1]) {
          return parts[i + 1];
        }

        // fallback to last segment (without using .at)
        return parts.length ? parts[parts.length - 1] : '';
      } catch {}
    }
    return '';
  }
  async function onColorChange(input){
    const handle = handleFromSwatch(input);
    if (!handle || handle === activeHandle) return;

    const lab = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const colorName = lab?.getAttribute('title') || lab?.getAttribute('aria-label') || input.value || '';
    if (colorLegendText) colorLegendText.textContent = colorName;

    // Swap the brand-colour description in the SAME DOM-write batch as the colour name.
    // The description is baked onto each swatch input as data-desc (see jn-variant-picker.liquid).
    setColorDesc(input.dataset.desc);

    // change path to sibling product (no variant yet)
    setURL(handle, null);
    activeHandle = handle;
    picker.setAttribute('handle', handle);

    const product = await getProduct(handle);
    if (!product) return;
    if (activeHandle !== handle) return; // user switched colour again during the fetch
    lastProduct = product;

    // A colour swatch loads a DIFFERENT product (new GID), so repoint the wishlist
    // heart / drop-a-hint / view-wishlist controls and re-check this colour's saved state.
    if (window.JNWishlist && window.JNWishlist.setPdpProduct) {
      window.JNWishlist.setPdpProduct({ id: product.id, handle: product.handle, title: product.title });
    }

    // Fix 3: show the new colour's main image this frame (cheap in-place swap of slide 1).
    renderGalleryPrimary(product);

    // Reflect the newly selected colour's price this frame. Sibling colours can differ in
    // price (full-price vs sale), so the displayed price + compare-at must not stay static on
    // a colour change. Use a representative variant now; renderSizes() refines it if the shopper
    // then picks a size. setPriceAndATC handles the sale strike-through via compare_at_price.
    {
      const repVariant = product.variants.find(v => v.available) || product.variants[0];
      if (repVariant) setPriceAndATC(repVariant);
    }

    // Sale-only messaging (e.g. "Final Sale") must reflect the NEW colour's sale status:
    // show it when the selected colour is on sale, hide it when it's full-price.
    {
      const saleTextEl = qs('.sale-text', SCOPE);
      if (saleTextEl) {
        const colourOnSale = (product.tags || []).some(t => String(t).toLowerCase() === 'price:sale');
        saleTextEl.hidden = !colourOnSale;
      }
    }

    // Fix 1: yield PAST paint ONCE so the swatch selection + primary image paint before the
    // heavy rebuilds run — keeps them off the interaction and out of the INP measurement.
    // (getProduct is usually cache-served, so without this the rebuilds would run in the same
    // task as the click, before the browser can paint.)
    await afterPaint();
    if (activeHandle !== handle) return; // bail if user switched colour again during the yield

    // Run the full-gallery and size-list rebuilds in the SAME post-paint frame. They both
    // reflow the column (the gallery sits above the title/rating), so doing them together
    // settles the layout in one shift instead of bouncing across separate frames.
    renderGallery(product);                                 // full slides + thumbnails + dots
    renderSizes(product, null, {trackOnSelect: true});      // will also set ?variant for the chosen size
    reloadFamilyProductsById(product.id);
    // "Complete the set" (above ATC) is per-colourway too — re-fetch this colour's set.
    if (window.JNSetBuilder && window.JNSetBuilder.reloadForHandle) {
      window.JNSetBuilder.reloadForHandle(handle);
    }
  }

  // ---------- listeners (STRICTLY SCOPED) ----------
  document.addEventListener('change', (e) => {
    if (e.target?.closest?.('.quick-buy-modal__content')) return;
    const t = e.target;
    if (!IN_SCOPE(t)) return;
    if (t?.matches?.('input.js-sibling-swatch[type="radio"]')) queueMicrotask(() => onColorChange(t));
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target?.closest?.('.quick-buy-modal__content')) return;
    if (!IN_SCOPE(e.target)) return;
    const lbl = e.target?.closest?.('label[for]');
    if (!lbl) return;
    const input = document.getElementById(lbl.getAttribute('for'));
    if (input && IN_SCOPE(input) && input.matches('input.js-sibling-swatch[type="radio"]')) {
      queueMicrotask(() => onColorChange(input));
    }
  }, true);

  // ======================= PRELOAD: swatch main images =======================
  const preloadSeen = new Set();
  function ensurePreconnect(url) {
    try {
      const host = new URL(url, location.origin).origin;
      if (!document.querySelector(`link[rel="preconnect"][href="${host}"]`)) {
        const pre = document.createElement('link');
        pre.rel = 'preconnect';
        pre.href = host;
        pre.crossOrigin = '';
        document.head.appendChild(pre);
        const dns = document.createElement('link');
        dns.rel = 'dns-prefetch';
        dns.href = host;
        document.head.appendChild(dns);
      }
    } catch {}
  }
  function preloadImageSet(rawUrl) {
    if (!rawUrl) return;
    const base = String(rawUrl).replace(/^\/\//,'https://');
    if (preloadSeen.has(base)) return;
    preloadSeen.add(base);

    ensurePreconnect(base);

    const ss = srcset(base);
    // Preload via <link> (Chrome supports imagesrcset/imagesizes)
    try {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as  = 'image';
      link.href = withW(base, 1000);
      link.setAttribute('imagesrcset', ss);
      link.setAttribute('imagesizes', GALLERY_SIZES);
      link.fetchPriority = 'low';
      document.head.appendChild(link);
    } catch {}

    // Warm via Image() as a fallback
    try {
      const img = new Image();
      img.decoding = 'async';
      img.sizes = GALLERY_SIZES;
      img.srcset = ss;
      img.src = withW(base, 1000);
      // optional: img.fetchPriority = 'low';
      img.style.position = 'absolute'; img.style.width = '0'; img.style.height = '0'; img.style.clipPath = 'inset(50%)';
      img.onload = img.onerror = () => { if (img.remove) img.remove(); };
      // not appended; browser will fetch anyway
    } catch {}
  }
  function collectSwatchImages() {
    const urls = new Set();
    // inputs
    qsa('input.js-sibling-swatch[type="radio"]', SCOPE).forEach(inp => {
      if (inp.dataset.image) urls.add(inp.dataset.image);
      const lbl = document.querySelector(`label[for="${inp.id}"]`);
      if (lbl?.dataset?.image) urls.add(lbl.dataset.image);
    });
    // also any swatch buttons/labels with data-image inside the color fieldset
    if (colorFS) qsa('[data-image]', colorFS).forEach(el => urls.add(el.dataset.image));
    return Array.from(urls);
  }
  function scheduleInitialPreload() {
    const urls = collectSwatchImages();
    urls.forEach((u, i) => {
      // Stagger to be kind to the network
      setTimeout(() => preloadImageSet(u), i * 150);
    });
  }
  // Hover/focus = immediate preload for that swatch
  document.addEventListener('mouseenter', (e) => {
    if (!IN_SCOPE(e.target)) return;
    const lbl = e.target.closest?.('label[for], [data-image]');
    if (!lbl) return;
    const url = lbl.dataset?.image || (() => {
      const id = lbl.getAttribute?.('for');
      return id ? document.getElementById(id)?.dataset?.image : null;
    })();
    if (url) preloadImageSet(url);
  }, true);
  document.addEventListener('focusin', (e) => {
    if (!IN_SCOPE(e.target)) return;
    const el = e.target.closest?.('[data-image]') || e.target;
    const url = el?.dataset?.image;
    if (url) preloadImageSet(url);
  }, true);
  // ==========================================================================

  // ---------- init ----------
  (async () => {
    const product = await getProduct(activeHandle);
    if (!product) return;
    lastProduct = product;

    renderGallery(product);        // ensure nav exists + bind interactions
    scheduleInitialPreload();      // PRELOAD swatch main images (staggered)

    // Ensure the brand-colour description is shown on load, independent of server-render timing.
    const checkedSwatch = colorFS?.querySelector('input.js-sibling-swatch:checked')
                       || colorFS?.querySelector('input.js-sibling-swatch');
    if (checkedSwatch) setColorDesc(checkedSwatch.dataset.desc);

    if (urlVariant && product.variants.some(v => v.id === urlVariant)) {
      renderSizes(product, urlVariant, {trackOnSelect: false}); // preselect exact ID from URL
      setURL(product.handle || activeHandle, urlVariant);
    } else {
      const autoId = findFitVariant(product);
      if (autoId) fromCookiePreset = true;
      renderSizes(product, autoId, {trackOnSelect: false});
    }
  })();

  // Re-render picker when bra size modal saves a new size
  document.addEventListener('jnBraSizeSet', function () {
    if (!lastProduct) return;
    fromCookiePreset = true;
    userChoseBraSize = true;
    const newId = findFitVariant(lastProduct);
    renderSizes(lastProduct, newId, { trackOnSelect: false });
  });

  // Re-render picker when panty size modal saves a new size
  document.addEventListener('jnPantySizeSet', function () {
    if (!lastProduct) return;
    fromCookiePreset = true;
    fromPantyCookiePreset = true;
    const newId = findFitVariant(lastProduct);
    renderSizes(lastProduct, newId, { trackOnSelect: false });
  });
})();

(function () {
  const mq = window.matchMedia('(max-width: 999px)'); // matches md:hidden
  document.addEventListener('click', (e) => {
    if (!mq.matches) return;                                    // mobile only
    const gallery = e.target.closest('product-gallery');
    if (!gallery) return;
    if (!e.target.closest('.product-gallery__carousel')) return; // only image area
    if (e.target.closest('video, video-media, [data-media-type="video"]')) return; // not on videos
    if (e.target.closest('button, a, [role="button"], .no-tap-zoom')) return; // don't hijack controls
    gallery.querySelector('.product-gallery__zoom-button')?.click();
  }, { passive: true });
})();
